
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';


// component
const Component: React.FunctionComponent<any> = (props: InputText<string>): JSX.Element =>{

    const { id , className , OnClick ,text } = props;

    return(
        
       <button id={id} className={className} onClick={OnClick}>{text}</button>
           
    )
}

// interface 
interface InputText<T >{
    id : string,
    text: T,
    className: T,
    OnClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>
}

/**
 * DefaultProps values
 */
Component.defaultProps= {

}
/**
 * mapStateToProps
 */


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/input-bouton/component.tsx